export class Pubsub {
    constructor() {
        this.containers = {};
    }

    register(name, func) {
        if (!this.containers[name]) {
            this.containers[name] = [func];
        } else {
            this.containers[name].push(func);
        }
    }

    publish(name, payload) {
        if (!this.containers[name] || this.containers[name].length === 0) {
            return
        }
        this.containers[name].forEach((func) => {
            func(payload)
        })
    }
}

// event bus
// 全局注册事件，同步传递短消息

// 路由返回事件
export const EVENT_ROUTER_BACK = "router-back";

export const PubSubGlobal = new Pubsub();
